import {oktaAuth} from '../../App';
import CallUsIcon from '../../assets/svg/call.svg';
import WarningIcon from '../../assets/svg/Vector.svg';
import JDFLogo from '../../assets/svg/Logo.svg';
import MailUsIcon from '../../assets/svg/mail.svg';
import HelpIcon from '../../assets/svg/needHelp.svg';
import YoutubeIcon from '../../assets/svg/youtube.svg';
import InputWidget from '../../lib/InputWidget/InputWidget';
import LanguageSelect from '../../lib/LanguageSelect/LanguageSelect';
import PopupModal from '../../lib/popupModel/popupModel';
import {
  NRStatus,
  SPAIN_COUNTRY_CODE,
  ONBOARD_VIDEO_UNLEASH_KEY,
  PORTUGAL_COUNTRY_CODE,
  PORTUGAL_UNLEASH_KEY,
} from '../../utils/constant';
import Smartlook from '../../utils/smartlook';
import {
  sendCustomDataNR,
  sendScreenViewNR,
  callNumber,
  replaceTranslations,
} from '../../utils/util';

import {
  Alert,
  Button,
  Link,
  CircularProgress,
  Modal,
  ModalActions,
  ModalContent,
  ModalContentText,
  ModalTitle,
} from '@deere/fuel-react';
import {Grid} from '@mui/material';
import {useFlag, useVariant} from '@unleash/proxy-client-react';
import './SecurityVerificationForm.css';
import React from 'react';
import {useNavigate} from 'react-router-dom';
import {useTranslation} from 'react-i18next';

const SecurityVerificationForm = ({
  errorMessage,
  maskedEmail,
  alert,
  formFields,
  handleSubmit,
  disableBtn,
  countryChangeHandler,
  currentFormStep,
  loading,
  showFAQMenu,
  forgotUniqueID,
  selectedCountry,
  unsecureRoute,
  closeAlreadyMappedPopup,
}) => {
  const [visible, setVisible] = React.useState(false);
  const {t} = useTranslation();
  const navigate = useNavigate();
  const showVideo = useFlag(ONBOARD_VIDEO_UNLEASH_KEY);
  const videoVariant = useVariant(ONBOARD_VIDEO_UNLEASH_KEY);
  const videoUrl = videoVariant?.payload?.value;
  const isPortugalEnabled = useFlag(PORTUGAL_UNLEASH_KEY);
  const NR_ACTION = 'SecurityVerification';
  const forgetUserNamePwdLink = import.meta.env.VITE_FORGET_USERNAME_PWD;
  const isAlreadyMappedPopupOpen = alert && errorMessage === 'ALREADY_MAPPED';

  const recoverAccount = () => {
    globalThis.open(forgetUserNamePwdLink, '_blank', 'noopener,noreferrer');
  };

  React.useEffect(() => {
    sendScreenViewNR('MyFinancialsLogin');
    sendCustomDataNR(
      NR_ACTION,
      sessionStorage.getItem('trace-id'),
      localStorage.getItem('countryCode'),
      null,
      NRStatus.landed
    );
    Smartlook.navigation('securityVerification');
  }, []);

  React.useEffect(() => {
    if (currentFormStep === 1) {
      sendScreenViewNR('SecurityVerificationStep1');
      Smartlook.navigation('SecurityVerificationStep1');
    } else if (currentFormStep === 2) {
      sendScreenViewNR('SecurityVerificationStep2');
      Smartlook.navigation('SecurityVerificationStep2');
    }
  }, [currentFormStep]);

  return (
    <div className="SecurityVerificationContent">
      <div>
        <div className="SecurityVerificationHeading">
          <div className="jdf-logo">
            <img src={JDFLogo} alt="JDF Logo" />
          </div>
          <div className="">
            <h2>{t('ACCOUNT_DETAILS')}</h2>
          </div>
          <p id="SubHeading">{t('SECURITY_VERIFICATION_SUBHEADING')}</p>
          {currentFormStep == 1 && (
            <div className="language-wrapper">
              <LanguageSelect
                languages={[
                  'es',
                  'gb',
                  'de',
                  ...(isPortugalEnabled ? ['pt'] : []),
                ]}
                value={selectedCountry}
                setValue={countryChangeHandler}
              />
            </div>
          )}
        </div>
      </div>
      <div className="SecurityVerificationContainer">
        <div className="SecurityVerificationForm">
          <div className="SecurityVerificationFormHeading">
            {t('ACCOUNT_INFORMATION')}
            <span>
              {replaceTranslations(
                t('SECURITY_VERIFICATION_STEP'),
                currentFormStep
              )}
            </span>
          </div>
          {alert && errorMessage !== 'ALREADY_MAPPED' && (
            <Alert
              variant="error"
              title={errorMessage ? t(errorMessage) : t('ACCOUNT_NOT_FOUND')}
              className="SecurityVerificationAlert"
            >
              {errorMessage ? null : t('ACCOUNT_NOT_FOUND_SUBHEADING')}
            </Alert>
          )}
          {currentFormStep == 2 && (
            <Alert variant="info" className="SecurityVerificationAlertInfo">
              {t('NAME_STEP_INSTRUCTION')}
            </Alert>
          )}
          <form>
            <Grid container flexDirection="column" spacing={4}>
              {formFields.map((i, index) => {
                return (
                  !i.isHidden &&
                  currentFormStep == i.step && (
                    <Grid item key={i.id}>
                      <InputWidget
                        required={i.required}
                        type={i.type}
                        id={i.id}
                        label={t(i.label)}
                        value={i.value}
                        setValue={i.setValue}
                        customError={false}
                        error={i.error}
                        helperText={t(i.helperText)}
                        infoIconText={i.infoIconText}
                      />
                    </Grid>
                  )
                );
              })}
              <p className="getCustomerId">
                {currentFormStep == 1 &&
                  selectedCountry !== SPAIN_COUNTRY_CODE &&
                  selectedCountry !== PORTUGAL_COUNTRY_CODE && (
                    <Link onClick={forgotUniqueID}>{t('GET_UNIQUE_ID')}</Link>
                  )}
              </p>
              <div className="SecurityVerificationAction">
                <Grid item>
                  <Button
                    type="button"
                    onClick={handleSubmit}
                    variant="primary"
                    id="continueButton"
                    disabled={disableBtn}
                    startIcon={
                      loading &&
                      currentFormStep == 1 && (
                        <CircularProgress
                          size="small"
                          style={{color: '#000'}}
                        />
                      )
                    }
                  >
                    {currentFormStep == 1
                      ? t('SECURITY_VER_NEXT')
                      : t('CONTINUE')}
                  </Button>
                </Grid>
                <Grid item>
                  <Button
                    type="button"
                    onClick={() => setVisible(true)}
                    variant="secondary"
                    id="cancelButton"
                  >
                    {t('EXIT_ACCOUNT_VERIFICATION')}
                  </Button>
                </Grid>
              </div>
              <Grid item>
                <p className="needAssistanceText">{t('NEED_ASSISTANCE')}</p>
              </Grid>
              <Grid item className="SecurityVerificationFAQ">
                {showVideo && (
                  <div id="youtubeLink">
                    <Link
                      href={videoUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      data-country={selectedCountry}
                    >
                      <img src={YoutubeIcon} alt="YouTube" />
                      {t('SIGN_UP_GUIDE')}
                    </Link>
                  </div>
                )}
                <div id="helpLink">
                  <Link onClick={showFAQMenu} data-country={selectedCountry}>
                    <img src={HelpIcon} alt="Help" />
                    {t('NEED_HELP')}
                  </Link>
                </div>
                <div id="mailUsLink">
                  <Link
                    href={`mailto:${t('CUSTOMER_CARE_EMAIL')}`}
                    data-country={selectedCountry}
                  >
                    <img src={MailUsIcon} alt="Mail" />
                    {t('EMAIL_US')}
                  </Link>
                </div>
                <div id="callUsLink">
                  <Link
                    href={`tel:${t('CUSTOMER_CARE_NUMBER')}`}
                    onClick={() => callNumber(t('CUSTOMER_CARE_NUMBER'))}
                    data-country={selectedCountry}
                  >
                    <img src={CallUsIcon} alt="Call" />
                    {t('CALL_US')}
                  </Link>
                </div>
              </Grid>
            </Grid>
          </form>
        </div>
        <PopupModal
          id="signOutPopupModal"
          title={t('ATTENTION')}
          description={t('SECURITY_VERIFICATION_EXIT')}
          action={t('EXIT')}
          visible={visible}
          setVisible={setVisible}
          signoutPopup={oktaAuth}
          type="secondary"
          isSecurityVerification={true}
          unsecureRoute={unsecureRoute}
        />
        <Modal
          className="AccountAlreadyExistsModal"
          open={isAlreadyMappedPopupOpen}
          onClose={closeAlreadyMappedPopup}
          aria-labelledby="already-mapped-modal-title"
          aria-describedby="already-mapped-modal-description"
        >
          <ModalTitle
            id="already-mapped-modal-title"
            className="AccountAlreadyExistsCloseRow"
          />
          <ModalContent className="AccountAlreadyExistsContent">
            <img
              src={WarningIcon}
              alt=""
              className="AccountAlreadyExistsIcon"
            />
            <h2 className="AccountAlreadyExistsTitle">
              {t('ACCOUNT_ALREADY_EXISTS_TITLE')}
            </h2>
            <ModalContentText id="already-mapped-modal-description">
              {t('ACCOUNT_ALREADY_EXISTS_DESC1')}{' '}
              <strong>{maskedEmail || t('YOUR_REGISTERED_EMAIL')}</strong>
            </ModalContentText>
            <ModalContentText>
              {t('ACCOUNT_ALREADY_EXISTS_DESC2')}
            </ModalContentText>
          </ModalContent>
          <ModalActions className="AccountAlreadyExistsActions">
            <Button
              id="recoverAccountButton"
              variant="primary"
              onClick={recoverAccount}
            >
              {t('RECOVER_YOUR_ACCOUNT')}
            </Button>
            <Button
              id="returnToSignInButton"
              variant="secondary"
              onClick={() => navigate('/')}
            >
              {t('RETURN_TO_SIGN_IN')}
            </Button>
          </ModalActions>
        </Modal>
      </div>
    </div>
  );
};

export default SecurityVerificationForm;
